import React from "react";
import { Prompt } from "react-router-dom";
import FoodForm from "./FoodForm";
import * as foodApi from "../api/food";
import { toast } from "react-toastify";

class FoodPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);

        this.state = {
            food: {
                name: "",
                category: 6,
                portion: 0,
                portionUnit: 1,
                calories: 0,
                carbs: 0,
                proteins: 0,
                fats: 0,
                fibre: undefined,
                sodium: undefined,
                autoDiet: false,
                minPortion: 0,
                maxPortion: 0,
                piecePortion: undefined,
                piecePortionUnit: undefined,
                addedBy: this.props.user.id
            },
            preventRedirect: false,
            saved: false
        };
    }

    async componentDidMount() {
        const foodId = this.props.match.params.foodId;
        if (foodId) {
            try {
                let editedfood = await foodApi.getFood(foodId);
                this.setState({ food: editedfood });
            } catch {
                toast.error("Error al obtener alimento");
            }
        }
    }

    componentDidUpdate() {
        if (this.state.saved) this.props.history.push("/foodDB");
    }

    handleChange(
        event,
        dataType = "",
        objName = event.target.id,
        value = event.target.value,
        isValid = true
    ) {
        if (dataType === "check") value = event.target.checked;
        else if (dataType === "select") value = Number(event.target.value);

        const updatedFood = { ...this.state.food, [objName]: value };
        this.setState({ food: updatedFood, preventRedirect: true });
        if (!isValid) toast.error("Numero no valido");
    }

    async handleSave(event) {
        event.preventDefault();
        let food = this.state.food;
        let calcCals = (food.fats * 9) + ((food.proteins + food.carbs) * 4);
        let diff = Math.abs(food.calories - calcCals);
        if (diff > food.calories * .1)
            toast.error("No concuerda la suma de calorias de carbohidratos, grasas y proteinas");
        else {
            try {
                if (food.id) {
                    await foodApi.updateFood(food.id, food);
                }
                else {
                    await foodApi.addFood(food);
                }
                this.setState({ preventRedirect: false, saved: true });
                toast.success("Alimento guardado exitosamente");
            }
            catch (error) {
                toast.error("Hubo un error al guardar");
            }
        }
    }

    render() {
        return (
            <>
                <h2>Food</h2>
                <Prompt
                    when={this.state.preventRedirect}
                    message="Estas seguro que deseas abandonar esta pagina sin guardar tus cambios?"
                />
                <FoodForm
                    food={this.state.food}
                    onChange={this.handleChange}
                    onSubmit={this.handleSave}
                />
            </>
        );
    }
}

export default FoodPage;
